import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { locationServicePageService } from '../services/locationServicePageService';
import { message } from 'antd';
import { LocationServicePage } from '../types/locationServicePage';

export const useLocationServicePages = (tenantId: string, status?: string) => {
  return useQuery({
    queryKey: ['location-service-pages', tenantId, status],
    queryFn: () => locationServicePageService.list(tenantId, status),
    enabled: !!tenantId,
  });
};

export const useLocationServicePage = (id: string) => {
  return useQuery({
    queryKey: ['location-service-page', id],
    queryFn: () => locationServicePageService.get(id),
    enabled: !!id,
  });
};

export const useGenerateLocationServicePageWithCrew = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: locationServicePageService.generateWithCrew,
        onSuccess: () => {
            message.success('Crew kickoff successful');
            queryClient.invalidateQueries({ queryKey: ['location-service-pages'] }); 
        },
        onError: () => {
            message.error('Failed to start crew');
        }
    })
}

export const useUpdateLocationServicePage = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({id, data}: {id: string, data: Partial<LocationServicePage>}) => locationServicePageService.update(id, data),
        onSuccess: (_, vars) => {
             message.success('Page updated');
             queryClient.invalidateQueries({ queryKey: ['location-service-pages'] });
             queryClient.invalidateQueries({ queryKey: ['location-service-page', vars.id] });
        }
    })
}

export const useDeleteLocationServicePage = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id: string) => locationServicePageService.delete(id),
        onSuccess: () => {
             message.success('Page deleted');
             queryClient.invalidateQueries({ queryKey: ['location-service-pages'] });
        }
    })
}

export const usePublishLocationServicePage = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id: string) => locationServicePageService.publish(id),
        onSuccess: (_, id) => {
             message.success('Page published');
             queryClient.invalidateQueries({ queryKey: ['location-service-pages'] });
             queryClient.invalidateQueries({ queryKey: ['location-service-page', id] });
        }
    })
}
